import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import {
//   User,
  Mail,
  Phone,
  MapPin,
  Building,
  Calendar,
  Edit2,
  Camera,
  Shield,
  Key,
  Globe,
  Briefcase
} from 'lucide-react';
import './Profile.css';

const initialProfile = {
  name: "John Doe",
  email: "john.doe@example.com",
  phone: "+33 1 45 26 75 23",
  location: "Paris, France",
  company: "SNCF Inc.",
  joinDate: "Mars 2022",
  avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&q=80",
  bio: "Je suis super fort dans tout et c'est ça qui est important mais si il y a bien un point sur lequel je suis au dessus c'est les grèves. Point fort : les grèves.",
  skills: ["Faire la grève", "Organiser des manifs", "Conduire des trains", "Faire la grève encore"],
  recentActivity: [
    {
      id: 1,
      action: "Début de grève",
      date: "2 hours ago"
    },
    {
      id: 2,
      action: "Retour de vacances",
      date: "1 day ago"
    },
    {
      id: 3,
      action: "Fin de grève - Début des vacances",
      date: "5 months ago"
    }
  ]
};

function Profile() {
  const [profile, setProfile] = useState(initialProfile);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleEditProfile = (event) => {
    event.preventDefault();
    // Add logic to save profile changes
    setShowEditModal(false);
  };

  const handleChangePassword = (event) => {
    event.preventDefault();
    // Add logic to change password
    setShowPasswordModal(false);
  };

  return (
    <Container fluid className="p-4 bg-light min-vh-100">
      {/* Header */}
      <div className="mb-4">
        <h1 className="h3 mb-0">Profile</h1>
        <p className="text-muted">Manage your account settings and preferences</p>
      </div>

      <Row className="g-4">
        {/* Profile Overview */}
        <Col lg={4}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="text-center">
              <div className="position-relative mb-4 mx-auto">
                <img
                  src={profile.avatar}
                  alt=""
                  className="profile-avatar rounded-circle"
                />
                <Button
                  variant="primary"
                  size="sm"
                  className="position-absolute bottom-0 end-0 rounded-circle p-2"
                >
                  <Camera size={16} />
                </Button>
              </div>
              <h5 className="mb-1">{profile.name}</h5>
              <p className="text-muted mb-3">{profile.role}</p>
              <div className="d-grid gap-2">
                <Button
                  variant="primary"
                  onClick={() => setShowEditModal(true)}
                >
                  <Edit2 size={18} className="me-2" />
                  Edit Profile
                </Button>
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPasswordModal(true)}
                >
                  <Key size={18} className="me-2" />
                  Change Password
                </Button>
              </div>
            </Card.Body>
            <hr className="my-0" />
            <Card.Body>
              <div className="mb-3">
                <h6 className="text-uppercase text-muted fw-semibold small">Contact Information</h6>
                <div className="d-flex align-items-center mb-2">
                  <Mail size={18} className="text-muted me-2" />
                  <span>{profile.email}</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <Phone size={18} className="text-muted me-2" />
                  <span>{profile.phone}</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <MapPin size={18} className="text-muted me-2" />
                  <span>{profile.location}</span>
                </div>
                <div className="d-flex align-items-center">
                  <Building size={18} className="text-muted me-2" />
                  <span>{profile.company}</span>
                </div>
              </div>
              <div>
                <h6 className="text-uppercase text-muted fw-semibold small">Skills</h6>
                <div className="d-flex flex-wrap gap-2">
                  {profile.skills.map((skill, index) => (
                    <span key={index} className="badge bg-primary-subtle text-primary">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Main Content */}
        <Col lg={8}>
          <Row className="g-4">
            {/* Bio */}
            <Col xs={12}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <h6 className="text-uppercase text-muted fw-semibold small mb-3">About</h6>
                  <p className="mb-0">{profile.bio}</p>
                </Card.Body>
              </Card>
            </Col>

            {/* Stats */}
            <Col sm={6} xl={3}>
              <Card className="border-0 shadow-sm stat-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-container bg-primary-subtle">
                      <Briefcase size={24} className="text-primary" />
                    </div>
                  </div>
                  <div className="text-muted small">Products Managed</div>
                  <div className="h4 mb-0">124</div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="border-0 shadow-sm stat-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-container bg-success-subtle">
                      <Globe size={24} className="text-success" />
                    </div>
                  </div>
                  <div className="text-muted small">Active Markets</div>
                  <div className="h4 mb-0">12</div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="border-0 shadow-sm stat-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-container bg-warning-subtle">
                      <Calendar size={24} className="text-warning" />
                    </div>
                  </div>
                  <div className="text-muted small">Days Active</div>
                  <div className="h4 mb-0">365</div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="border-0 shadow-sm stat-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-container bg-info-subtle">
                      <Shield size={24} className="text-info" />
                    </div>
                  </div>
                  <div className="text-muted small">Role Level</div>
                  <div className="h4 mb-0">Admin</div>
                </Card.Body>
              </Card>
            </Col>

            {/* Recent Activity */}
            <Col xs={12}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <h6 className="text-uppercase text-muted fw-semibold small mb-3">Recent Activity</h6>
                  <div className="activity-timeline">
                    {profile.recentActivity.map((activity) => (
                      <div key={activity.id} className="activity-item">
                        <div className="activity-content">
                          <div className="fw-medium">{activity.action}</div>
                          <small className="text-muted">{activity.date}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Edit Profile Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEditProfile}>
          <Modal.Body>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={profile.name}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    defaultValue={profile.email}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    defaultValue={profile.phone}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Location</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={profile.location}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={profile.company}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Role</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={profile.role}
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Bio</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    defaultValue={profile.bio}
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Skills</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={profile.skills.join(", ")}
                    placeholder="Separate skills with commas"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Change Password Modal */}
      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleChangePassword}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Change Password
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}

export default Profile;